import React from 'react';
import { Link } from 'react-router-dom';
import StatItem from '../../../components/StatItem';
import HeroNetwork from './HeroNetwork';
import './HeroSection.css';

interface Stat {
  number: string;
  label: string;
}

interface HeroSectionProps {
  id?: string;
  badge?: string;
  title: string;
  titleGradient?: string;
  description?: string;
  primaryAction?: {
    label: string;
    to: string;
  };
  secondaryAction?: {
    label: string;
    href: string;
  };
  stats?: Stat[];
}

const HeroSection: React.FC<HeroSectionProps> = ({
  id,
  badge,
  title,
  titleGradient,
  description,
  primaryAction,
  secondaryAction,
  stats = [],
}) => {
  return (
    <section id={id} className="consulting-hero">
      <div className="hero-atmosphere" aria-hidden="true">
        <div className="hero-orb hero-orb-a" />
        <div className="hero-orb hero-orb-b" />
        <div className="hero-orb hero-orb-c" />
        <div className="hero-grid" />
        <HeroNetwork />
        <div className="hero-sheen" />
      </div>
      <div className="hero-content">
        {badge && <div className="hero-badge">{badge}</div>}
        <h1 className="hero-title">
          {title}
          {titleGradient && <span className="gradient-text">{titleGradient}</span>}
        </h1>
        {description && <p className="hero-description">{description}</p>}
        {(primaryAction || secondaryAction) && (
          <div className="hero-actions">
            {primaryAction && (
              <Link to={primaryAction.to}>
                <button className="btn-primary btn-large">{primaryAction.label}</button>
              </Link>
            )}
            {secondaryAction && (
              <a href={secondaryAction.href}>
                <button className="btn-secondary btn-large">{secondaryAction.label}</button>
              </a>
            )}
          </div>
        )}
        {stats.length > 0 && (
          <div className="hero-stats">
            {stats.map((stat, index) => (
              <StatItem key={index} number={stat.number} label={stat.label} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
